/* eslint-disable import/no-cycle */
import { AchType } from './Ach';
import { IAddress } from './Address';
import { DisbursementMethod } from './Employee';
import { IHoldbackFixed, IHoldbackPercent } from './Holdback';
import { ISiteIntegration } from './Integration';
import { IOrganization } from './Organization';
import { IPayoutsPolicies } from './Payout';

export enum PaymentProcessor {
  INGO = 'ingo',
  TABAPAY = 'tabapay',
}

export enum RechargeMethod {
  AUTO = 'auto',
  MANUAL = 'manual',
}

export enum SiteStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum TipCalculatorRuleConfiguration {
  STANDARD = 'standard',
  ADVANCED = 'advanced',
}

export enum TipCalculatorSafeModeStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export interface IBaseSite {
  id: string;
  name: string;
  legalName: string;
  websiteUrl: string;
  address: IAddress;
  status: SiteStatus;
  organization: IOrganization;
  createdAt: string;
  updatedAt: string;
}

export interface ISiteAcceptanceSettings {
  enabled: boolean;
  displayName?: string;
  perTipMax?: number;
  perTipMin?: number;
}

export interface ISite extends IBaseSite {
  customerSiteId?: string;
  acceptance: ISiteAcceptanceSettings;
  companyType: string;
  email: string;
  phone: string;
  taxpayerId: string;
  stats: ISiteStats;
  settings: ISiteSettings;
  integrations: ISiteIntegration[];
  meta?: { salesForce?: string };
  approvalPolicies?: ISiteApprovalPolicies;
  accountBalance?: number;
  acceptanceBalance?: number;
}

interface ISiteApprovalPolicies {
  payouts?: IPayoutsPolicies;
}

export interface IPaySchedule {
  anchorDate: string;
  frequency: string;
  payDay1?: string;
  payDay2?: string;
}

export interface IPolicy {
  payable: boolean;
  paySelf: boolean;
  holdbackAdjustment: boolean;
}

export interface ISiteRolePolicy {
  organizationAdmin: IPolicy;
  siteAdmin: IPolicy;
  siteManager: IPolicy;
}

export interface ISiteStats {
  balance: { acceptance: number; current: number; pendingFunds: number; rechargeAmount: number; updatedAt: string };
  employees: { actionRequired: number; approved: number; dismissed: number; invited: number; total: number };
  payouts: { expired: number; total: { count: number; gross: number; holdbacks: number; net: number } };
}

export interface ISiteSettings {
  achType: AchType;
  createPayments: boolean;
  disbursementMethod: DisbursementMethod;
  endDayMidnightOffset: number;
  holdback: IHoldbackFixed | IHoldbackPercent;
  overdraftLimit: number;
  paySchedule: IPaySchedule;
  requireEmployeeId: boolean;
  paymentProcessor: PaymentProcessor;
  perTipMax: number;
  rechargeMethod: RechargeMethod;
  retainer: number;
  strictTipPool: boolean;
  timezone: string;
  tipCalculator: boolean;
  useOrgDefaults: boolean;
  rolePolicy: ISiteRolePolicy;
  tipCalculatorPercentFee: number;
  tipCalculatorRuleConfiguration: TipCalculatorRuleConfiguration;
  tipCalculatorSafeMode: TipCalculatorSafeModeStatus;
  paymentCategories: string[];
}

export interface ISiteBalance {
  acceptance: number;
  acceptanceFees: number;
  current: number;
  pendingFunds: number;
  rechargeAmount: number;
}
